import React from "react";
import AppBreadcrumb from "../../components/CustomeBreadcrumb/AppBreadcrumb";
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { formatPageDate } from "../../appconfig/TemplateFieldSetting";
import ViewSinNumber from "../../components/ViewSinNumber/ViewSinNumber";

const EmployeeProfile = () => {
  document.title = "Employee Profile | Nexawage Payroll";

  // navigate
  const navigate = useNavigate();

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;
  const userRole = userData?.roles?.role_name || "";

  return (
    <>
      <AppBreadcrumb
        pageName="Profile"
        currentMenu="Employee"
        pageTitle={
          <>
            <div className="gotopage-button-header">
              <Button
                icon="pi pi-arrow-left"
                className="mr-2 common-p-gotopage-button"
                onClick={() => navigate("/employee-dashboard")}
              />
              <span className="span-text">Profile</span>
            </div>
          </>
        }
      />

      <Card className="p-0 bg-white" style={{ height: "calc(100% - 52px)" }}>
        <div className="grid">
          {/* name */}
          <div className="flex mb-3 col-12">
            <div className="">
              <label className="font-bold text-gray-700">Name :</label>
              <div className="flex gap-2 align-items-center">
                <h2 className="mt-1 mb-1 text-xl font-semibold text-gray-900">
                  {userData?.first_name ?? ""} {userData?.last_name ?? ""}
                </h2>
              </div>
            </div>
          </div>
          {/* other details */}
          <div className="col-12 md:col-12">
            <div className="grid p-fluid">
              {!window.cn(userData?.email) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Email:</label>
                  <div className="text-gray-900">{userData?.email || "-"}</div>
                </div>
              )}

              {!window.cn(userData?.phone) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Phone:</label>
                  <div className="text-gray-900">{userData?.phone || "-"}</div>
                </div>
              )}

              {!window.cn(userData?.joining_date) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">
                    Joining Date:
                  </label>
                  <div className="text-gray-900">
                    {userData?.joining_date
                      ? formatPageDate(userData?.joining_date)
                      : "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.date_of_birth) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">
                    Date Of Birth:
                  </label>
                  <div className="text-gray-900">
                    {userData?.date_of_birth
                      ? formatPageDate(userData?.date_of_birth)
                      : "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.vacation_hold) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>
                    {" "}
                    Is Vacation Payout On Hold:
                  </label>
                  <div>{userData?.vacation_hold === true ? "Yes" : "No"}</div>
                </div>
              )}

              {!window.cn(userData?.vaccation_payout) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Vacation Payout:</label>
                  <div>
                    {userData.vaccation_payout
                      ? `${userData.vaccation_payout}%`
                      : "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.supervisor) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Supervisor:</label>
                  <div>
                    {" "}
                    {userData?.user?.first_name} {userData?.user?.last_name}
                  </div>
                </div>
              )}

              {!window.cn(userData?.ei_exempt) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Is EI Exempt:</label>
                  <div>{userData?.ei_exempt === true ? "Yes" : "No"}</div>
                </div>
              )}

              {!window.cn(userData?.cpp_exempt) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Is CPP Exempt:</label>
                  <div>{userData?.cpp_exempt === true ? "Yes" : "No"}</div>
                </div>
              )}

              {!window.cn(userData?.wage) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Wage:</label>
                  <div>{userData.wage ? `$${userData.wage}` : "-"}</div>
                </div>
              )}

              {!window.cn(userData?.tax_deduction) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>Tax Deduction:</label>
                  <div>
                    {userData.tax_deduction
                      ? `${userData.tax_deduction}%`
                      : "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.sin_number) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label style={{ fontWeight: "bold" }}>SIN No:</label>
                  <ViewSinNumber
                    label="SIN Number"
                    value={userData?.sin_number}
                  />
                </div>
              )}

              {!window.cn(userData?.address) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">address:</label>
                  <div className="text-gray-900">{userData?.city || "-"}</div>
                </div>
              )}

              {!window.cn(userData?.city) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">City:</label>
                  <div className="text-gray-900">{userData?.city || "-"}</div>
                </div>
              )}

              {!window.cn(userData?.province) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">Province:</label>
                  <div className="text-gray-900">
                    {userData?.province || "-"}
                  </div>
                </div>
              )}

              {!window.cn(userData?.postal_code) && (
                <div className="mb-1 md:mb-3 col-12 sm:col-6 md:col-4 lg:col-3">
                  <label className="font-bold text-gray-700">
                    Postal Code:
                  </label>
                  <div className="text-gray-900">
                    {userData?.postal_code || "-"}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Card>
    </>
  );
};

export default EmployeeProfile;
